<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default
{
    name: 'mv-recommendation-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row" v-if="!edit">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.PROGRAM') }}
            </label>
            <div class="col-md-6">
                <mv-program-input v-model="model.program_id" @added="save"></mv-program-input>
            </div>
        </div>

        <div class="form-group row" v-if="edit">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TOP') }}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.top">
            </div>
        </div>
    </form>
</div>
</template>


// WEBPACK FOOTER //
// src/components/forms/RecommendationForm.vue